import { retrocessionModelByRole, type MemberRole, type SubscriptionPlan } from '@osteopro/shared';

/**
 * Qui voit l'écran Rétrocessions.
 *
 * L'offre Cabinet seulement : un ostéo seul n'a en général personne à qui rétroéder.
 * Le titulaire génère les fiches du cabinet. Un collaborateur, un salarié ou un remplaçant
 * n'imprime que la sienne — ce sont les seuls rôles qui ouvrent une rétrocession.
 * Le secrétariat ne facture pas. L'API lui laisse sa propre ligne, pas la lecture du cabinet,
 * et cette ligne n'existe pas : l'entrée reste fermée.
 */
export type RetrocessionScreenAccess = 'pending' | 'locked' | 'owner' | 'own' | 'none';

export function retrocessionScreenAccess(
  plan: SubscriptionPlan | undefined,
  role: MemberRole | undefined,
): RetrocessionScreenAccess {
  if (plan === undefined) return 'pending';
  if (plan !== 'cabinet') return 'locked';
  if (role === 'owner') return 'owner';
  if (role !== undefined && retrocessionModelByRole[role] !== undefined) return 'own';
  return 'none';
}

/** L'entrée de la barre principale. L'adresse, elle, reste servie et explique le refus. */
export function showsRetrocessionNav(
  plan: SubscriptionPlan | undefined,
  role: MemberRole | undefined,
): boolean {
  const access = retrocessionScreenAccess(plan, role);
  return access === 'owner' || access === 'own';
}
